
import { Form, Button, Input, Upload, Select, Modal } from "antd";
import "./AddNewDokumentForm.css";
import dokumentService from "../../services/dokument.service";
import { useState, useEffect } from "react";
import kategorijaDokumentaService from "../../services/kategorijaDokumenta.service";
import { UploadOutlined } from "@ant-design/icons";

import "./AddNewDokumentForm.css";

const AddNewDokumentForm = ({ onCancel, onDocumentAdded }) => {
  const [naziv, setNaziv] = useState("");
  const [autor, setAutor] = useState("");
  const [kategorije, setKategorije] = useState([]);
  const [kategorija, setKategorija] = useState(1);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchKategorije = async () => {
      try {
        const response = await kategorijaDokumentaService.getAll();
        setKategorije(response.data);
      } catch (error) {}
    };

    fetchKategorije();
  }, []);

  const isFormValid = () => {
    return naziv.trim() !== "" && autor.trim() !== "";
  };
  const handleAddDocument = async () => {
    if (!selectedFile) {
      setErrorMessage("Molimo Vas da izaberete dokument koji želite objaviti.");
      setIsErrorModalVisible(true);
      return;
    }
    if (!isFormValid()) {
      setErrorMessage(
        "Molimo Vas da popunite sva obavezna polja prije slanja."
      );
      setIsErrorModalVisible(true);
      return;
    }
    const formData = new FormData();
    formData.append("naziv", naziv);
    formData.append("autor", autor);
    formData.append("file", selectedFile);
    formData.append("kategorijaDokumentaId", kategorija);

    try {
      await dokumentService.uploadDokument(formData);
      onDocumentAdded();
      setNaziv("");
      setAutor("");
      setSelectedFile(null);
    } catch (error) {}
  };

  return (
    <div className="main-container">
      <div className="form_container">
        <h1 className="add-new-document-title">Novi dokument</h1>
        <Form
          layout="horizontal"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          className="document-form"
        >
          <Form.Item label="Naziv dokumenta" required>
            <Input
              className="input-field add-new-document-input"
              value={naziv}
              onChange={(e) => setNaziv(e.target.value)}
              placeholder="Unesite naziv dokumenta"
            />
          </Form.Item>

          <Form.Item label="Ime autora" required>
            <Input
              className="input-field add-new-document-input"
              value={autor}
              onChange={(e) => setAutor(e.target.value)}
              placeholder="Unesite ime autora"
            />
          </Form.Item>

          <Form.Item label="Kategorija">
            <Select
              className="select-field add-new-document-select"
              value={kategorija}
              onChange={setKategorija}
            >
              {kategorije.map((kat) => (
                <Select.Option key={kat.id} value={kat.id}>
                  {kat.naziv}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Izaberite dokument" required>
            <Upload
              beforeUpload={(file) => {
                setSelectedFile(file);
                return false;
              }}
              fileList={selectedFile ? [selectedFile] : []}
            >
              <Button className="button-izaberi-fajl" icon={<UploadOutlined />}>
                Izaberi fajl
              </Button>
            </Upload>
          </Form.Item>
        </Form>
      </div>
      <div className="button-container-document">
        <Button
          className="dodaj-dokument-btn"
          type="primary"
          onClick={handleAddDocument}
        >
          Dodaj dokument
        </Button>
        <Button className="odustani-btn" onClick={onCancel}>
          Odustani
        </Button>
      </div>
      <Modal
        title="Greška"
        visible={isErrorModalVisible}
        onOk={() => setIsErrorModalVisible(false)}
        onCancel={() => setIsErrorModalVisible(false)}
        okText="U redu"
        cancelText="Otkaži"
      >
        <p>{errorMessage}</p>
      </Modal>
    </div>
  );
};

export default AddNewDokumentForm;
